var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconValidationX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-1087.000000, -2519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/ValidationX",
    transform: "translate(1087.000000, 2519.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E03D51",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34616474,8 L11.5897726,10.2436079 C11.9615058,10.615341 11.9615058,11.2180395 11.5897726,11.5897726 C11.2180395,11.9615058 10.615341,11.9615058 10.2436079,11.5897726 L8,9.34616474 L5.7563921,11.5897726 C5.38465897,11.9615058 4.78196048,11.9615058 4.41022735,11.5897726 C4.03849423,11.2180395 4.03849423,10.615341 4.41022735,10.2436079 L6.65383526,8 L4.41022735,5.7563921 C4.03849423,5.38465897 4.03849423,4.78196048 4.41022735,4.41022735 C4.78196048,4.03849423 5.38465897,4.03849423 5.7563921,4.41022735 L8,6.65383526 L10.2436079,4.41022735 C10.615341,4.03849423 11.2180395,4.03849423 11.5897726,4.41022735 C11.9615058,4.78196048 11.9615058,5.38465897 11.5897726,5.7563921 L9.34616474,8 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValidationX);
export default __webpack_public_path__ + "static/media/iconValidationX.a7ca7746.svg";
export { ForwardRef as ReactComponent };